import type { ConfirmNavigationModalState } from './types';

export const getInitialModalDetails = (): ConfirmNavigationModalState => ({
    title: '',
    message: '',
    onConfirm: () => {
        // no-op: will be set when modal is triggered
    },
    onCancel: () => {
        // no-op: will be set when modal is triggered
    },
    show: false
});
